<ogr-icon class="icono-prueba" name="prueba"></ogr-icon>
